// CART-D UI (2026-05-26) — 내부 사용자(출품 업체/admin) 혼적 카트 입금 확인 페이지
// API: GET /api/carts/pending-payments → { carts:[{cartId,destCountry,companies:[{companyId,companyName,amountKrw,status}],fullyReceived}], isAdmin }
//      POST /api/carts/:cartId/payments/:companyId/mark-received → { payment, trigger }
//   전 업체 입금 확인 시 차량 면장신청 전이 + 선적일정 자동 생성(서버 트리거).
// ERP 한글 고정(buyer 앱과 달리 i18n 없음). TransactionsConfirmPage 패턴.

import React, { useState, useEffect, useCallback } from 'react';
import { getSocket } from '../utils/socket';
import { API, authFetch } from '../utils/api';

function won(n) { return (Number(n) || 0).toLocaleString('en-US'); }

var STATUS_LABEL = { pending: '입금 대기', received: '입금 확인됨' };

function CartPaymentsPage(props) {
  var showToast = props.showToast || function () {};
  var [carts, setCarts] = useState([]);
  var [loading, setLoading] = useState(true);
  var [error, setError] = useState('');
  var [busy, setBusy] = useState('');

  var load = useCallback(function () {
    setLoading(true); setError('');
    authFetch(API + '/carts/pending-payments')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success && d.data) setCarts(d.data.carts || []);
        else setError((d && d.error) || '목록 조회 실패');
        setLoading(false);
      })
      .catch(function () { setError('네트워크 오류'); setLoading(false); });
  }, []);
  useEffect(function () { load(); }, [load]);

  // 2026-05-28 — cart:received 실시간 sync (server cart-payments.js:77 emit).
  // 같은 cart 의 다른 seller 가 입금 확인 / admin 대리 확인 시 자동 새로고침.
  useEffect(function () {
    var sock;
    try { sock = getSocket(); } catch (e) { return; }
    if (!sock) return;
    var onReceived = function () { load(); };
    sock.on('cart:received', onReceived);
    return function () { try { sock.off('cart:received', onReceived); } catch (e) {} };
  }, [load]);

  function markReceived(cartId, companyId) {
    if (busy) return;
    if (!window.confirm('이 업체 송금 입금을 확인하시겠습니까?\n\n전 업체 입금 확인이 완료되면 차량이 면장신청으로 전이되고 선적 일정이 생성됩니다.')) return;
    setBusy(cartId + ':' + companyId);
    authFetch(API + '/carts/' + cartId + '/payments/' + companyId + '/mark-received', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}'
    })
      .then(function (r) { return r.json().then(function (d) { return { status: r.status, d: d }; }); })
      .then(function (res) {
        var d = res.d;
        if (d && d.success) {
          if (d.trigger && d.trigger.triggered) {
            var n = (d.trigger.cars && d.trigger.cars.length) || 0;
            showToast('입금 확인 — 전 업체 완료. 차량 ' + n + '대 면장신청 전이 + 일정 생성', 'success');
          } else {
            showToast('입금 확인 완료', 'success');
          }
          load();
        } else if (res.status === 409) {
          showToast((d && d.message) || '말소 미완료 차량 포함', 'error'); load();
        } else {
          showToast((d && d.message) || (d && d.error) || '확인 실패', 'error');
        }
        setBusy('');
      })
      .catch(function () { showToast('네트워크 오류', 'error'); setBusy(''); });
  }

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <h2 style={{ fontSize: 20, fontWeight: 800, color: '#1B3A5C', marginBottom: 4 }}>📦 혼적 입금 확인</h2>
      <p style={{ fontSize: 13, color: '#64748b', marginBottom: 20 }}>
        바이어가 송금한 차량 대금 입금을 확인합니다. 한 컨테이너의 전 업체 입금이 확인되면 차량이 자동으로 면장신청 단계로 전이되고 선적 일정이 생성됩니다.
      </p>

      {error && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: 12, marginBottom: 16, color: '#991b1b', fontSize: 14 }}>⚠ {error}</div>}

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8' }}>불러오는 중…</div>
      ) : carts.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8', background: 'white', borderRadius: 12, border: '1px solid #e2e8f0' }}>
          입금 확인 대기 중인 혼적 카트가 없습니다.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {carts.map(function (cart) {
            return (
              <div key={cart.cartId} style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: 18 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
                  <div style={{ fontSize: 15, fontWeight: 800, color: '#0f172a' }}>
                    카트 #{cart.cartId} · 🌍 {cart.destCountry || '-'}
                    {cart.fullyReceived
                      ? <span style={{ marginLeft: 10, fontSize: 12, fontWeight: 700, color: '#fff', background: '#10b981', padding: '2px 10px', borderRadius: 10 }}>전 업체 입금 완료</span>
                      : <span style={{ marginLeft: 10, fontSize: 12, fontWeight: 700, color: '#fff', background: '#f59e0b', padding: '2px 10px', borderRadius: 10 }}>입금 진행 중</span>}
                  </div>
                  <div style={{ fontSize: 13, color: '#64748b' }}>적재 {cart.totalCbm || 0} CBM · 총 ₩{won(cart.totalAmountKrw)}</div>
                </div>

                <div style={{ borderTop: '1px solid #f1f5f9' }}>
                  {cart.companies.map(function (c) {
                    var received = c.status === 'received';
                    var key = cart.cartId + ':' + c.companyId;
                    return (
                      <div key={c.companyId} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f8fafc' }}>
                        <div>
                          <span style={{ fontWeight: 700, color: '#0f172a' }}>{c.companyName}</span>
                          <span style={{ marginLeft: 10, fontSize: 13, color: '#475569' }}>₩{won(c.amountKrw)}</span>
                        </div>
                        {received ? (
                          <span style={{ fontSize: 13, fontWeight: 700, color: '#10b981' }}>✓ {STATUS_LABEL.received}</span>
                        ) : (
                          <button type="button" disabled={busy === key} onClick={function () { markReceived(cart.cartId, c.companyId); }}
                            style={{ height: 34, padding: '0 16px', border: 'none', borderRadius: 8, background: '#1B3A5C', color: 'white', fontSize: 13, fontWeight: 700, cursor: busy === key ? 'wait' : 'pointer', opacity: busy === key ? 0.6 : 1 }}>
                            입금 확인
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default CartPaymentsPage;
